import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import { MILES_AND_MORE } from "../../src/loyalty/miles-and-more";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "2f0a7fa5-2464-4aa6-9a5b-fc1ba466374b",
  title: "Lufthansa",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-GB",
  currency: "EUR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon.png"],
  logo: "/assets/images/logo.svg",
  domain: "lufthansa.coras.io",
  detectLocale: true,
  detectCurrency: true,
  linkedTravelNotice: {
    company: "Deutsche Lufthansa AG",
    companyPossessive: "Deutsche Lufthansa's",
    insolvencyProtectionUrl: {
      default: "https://www.lufthansa.com/xx/en/insolvency-protection",
      "de-DE":
        "https://www.lufthansa.com/de/de/discover-lufthansa/campaigns/insolvency-protection",
    },
  },
  loyalty: MILES_AND_MORE,
};
